import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { useCheckAccess, getCurrentDateTillHour } from "../../utils/Utilities";
import '../../pages/general/General.css';
import { queryExpenseCategoryConfig } from "../../service/UtilApi";
import { createExpense } from "../../service/ExpenseApi";
import { useNavigate } from 'react-router-dom';
const ExpenseCreate = () => {
  useCheckAccess('ExpenseRW');
  const navigate = useNavigate();
  const [form, setForm] = useState({
    category: '',
    subcategory: '',
    amount: '',
    comments: '',
    date: '',
    externalTransactionReference: '',
  });
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryError, setCategoryError] = useState('');
  const selectedCategory = categories.find(cat => cat.categoryName === form.category);
  const sortedSubcategories = selectedCategory?.subcategories
    ? [...selectedCategory.subcategories].sort((a, b) => a.name.localeCompare(b.name))
    : [];

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await queryExpenseCategoryConfig();
        if (response?.categoriesList?.length > 0) {
          setCategories(response.categoriesList);
        } else {
          setCategoryError("வகைகள் எதுவும் கிடைக்கவில்லை");
        }
      } catch {
        setCategoryError("வகைகளை ஏற்றுவதில் பிழை ஏற்பட்டது");
      }
    };

    fetchCategories();
  }, []);

  const generateExpenseId = ({ category, subcategory, amount }) => {
    if (!category || !subcategory || !amount) {
      throw new Error("Missing required input to generate expense ID");
    }

    const baseId = `${category}_${subcategory}_${amount}`
      .replace(/\s+/g, ''); // Remove all whitespace

    const currentDate = getCurrentDateTillHour(); // e.g., 2025-08-01_14

    return `${baseId}_${currentDate}`;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Reset subcategory if category is changed
    if (name === 'category') {
      setForm(prev => ({ ...prev, [name]: value, subcategory: '' }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.category || !form.subcategory || !form.amount || !form.date) {
      alert("அனைத்து கட்டங்களும் நிரப்ப வேண்டும்.");
      return;
    }

    setLoading(true);

    try {
      const expenseId = generateExpenseId({
        category: form.category,
        subcategory: form.subcategory,
        amount: form.amount,
      });

      const category = categories.find(cat => cat.categoryName === form.category);
      const subcategory = category?.subcategories?.find(sub => sub.name === form.subcategory);

      const payload = {
        ...form,
        amount: parseFloat(form.amount),
        expenseId,
        categoryDescription: category?.description || '',
        subCategoryDescription: subcategory?.description || '',
      };

      const response = await createExpense(payload);
      if (response) {
        alert('✅ செலவு வெற்றிகரமாக சேர்க்கப்பட்டது');
        navigate(`/expense/search?category=${encodeURIComponent(form.category)}&subcategory=${encodeURIComponent(form.subcategory)}`);
        setForm({
          category: '',
          subcategory: '',
          amount: '',
          comments: '',
          date: '',
          externalTransactionReference: ''

        });
      }
    } catch (error) {
      alert('⚠️ செலவினம் சேமிக்கையில் பிழை ஏற்பட்டது');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <Navbar />
      <Helmet><title>செலவினம் சேர்க்க</title></Helmet>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs />
            <br />
            <h2>புதிய செலவினத்தைச் சேர்க்கவும்</h2>
            <br />

            {categoryError && <p style={{ color: 'red' }}>{categoryError}</p>}

            <form onSubmit={handleSubmit} className="p-4 space-y-4">

              <div className="auth_element">
                <label>வகை:</label>
                {categories.length === 0 ? (
                  <p>வகைகள் ஏற்றப்படுகிறது...</p>
                ) : (
                  categories.map(cat => (
                    <div key={cat.categoryName}>
                      <label className="auth_radio">
                        <input
                          type="radio"
                          name="category"
                          value={cat.categoryName}
                          checked={form.category === cat.categoryName}
                          onChange={handleChange}
                        />
                        {cat.description}
                      </label>
                    </div>
                  ))
                )}
              </div>

              {sortedSubcategories.length > 0 && (
                <div className="auth_element">
                  <label>துணை வகை:</label>
                  {sortedSubcategories.map(sub => (
                    <div key={sub.name}>
                      <label className="auth_radio">
                        <input
                          type="radio"
                          name="subcategory"
                          value={sub.name}
                          checked={form.subcategory === sub.name}
                          onChange={handleChange}
                        />
                        {sub.description}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <input
                name="amount"
                type="number"
                placeholder="தொகை ₹"
                value={form.amount}
                onChange={handleChange}
                required
                min="0"
                step="0.01"
                pattern="^\d+(\.\d{1,2})?$"
                className="auth_input"
              />


              <input
                name="comments"
                maxLength={200}
                placeholder="விவரம்"
                value={form.comments}
                onChange={handleChange}
                required
                className="auth_input"
              />

              <input
                name="date"
                type="date"
                value={form.date}
                onChange={handleChange}
                required
                className="auth_input"
              />



              <input
                type="text"
                name="externalTransactionReference"
                maxLength={200}
                placeholder="விவரம்"
                value={form.externalTransactionReference}
                onChange={handleChange}
                className="auth_input"
              />

              <button
                type="submit"
                disabled={loading}
                className={`auth_submit ${loading ? "disabled_btn" : ""}`}
              >
                {loading ? 'சேமிக்கிறது...' : '✅ செலவினம் சேர்க்கவும்'}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ExpenseCreate;
